(function () {
  function initFaqSection(root) {
    if (!root || root.dataset.smsFaqInit === 'true') return;
    root.dataset.smsFaqInit = 'true';

    var searchInput = root.querySelector('[data-sms-faq-search]');
    var categoryButtons = root.querySelectorAll('[data-sms-faq-category]');
    var faqItems = root.querySelectorAll('[data-sms-faq-item]');
    var accordionButtons = root.querySelectorAll('[data-sms-faq-toggle]');
    var noResults = root.querySelector('[data-sms-faq-no-results]');
    var activeButton = root.querySelector('[data-sms-faq-category].is-active');

    var activeCategory = activeButton ? activeButton.dataset.smsFaqCategory : 'all';

    function normalize(value) {
      return String(value || '').toLowerCase().trim();
    }

    function setActiveButtons(category) {
      categoryButtons.forEach(function (button) {
        var isActive = button.dataset.smsFaqCategory === category;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function filterFaqs() {
      var query = normalize(searchInput ? searchInput.value : '');
      var visibleCount = 0;

      faqItems.forEach(function (item) {
        var itemCategory = item.dataset.smsFaqItemCategory || '';
        var searchable = normalize(item.textContent);
        var categoryMatch = activeCategory === 'all' || itemCategory === activeCategory;
        var searchMatch = !query || searchable.indexOf(query) !== -1;
        var shouldShow = categoryMatch && searchMatch;

        item.classList.toggle('is-hidden', !shouldShow);

        if (shouldShow) visibleCount += 1;
      });

      if (noResults) {
        noResults.classList.toggle('is-visible', visibleCount === 0);
      }
    }

    categoryButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeCategory = button.dataset.smsFaqCategory || 'all';
        setActiveButtons(activeCategory);
        filterFaqs();

        var list = root.querySelector('[data-sms-faq-list]');
        if (list && window.innerWidth < 990) {
          list.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    accordionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        var item = button.closest('[data-sms-faq-item]');

        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');

        if (item) {
          item.classList.toggle('is-open', !expanded);
        }

        var toggle = button.querySelector('.sms-faq-item__toggle');
        if (toggle) {
          toggle.textContent = expanded ? '+' : '–';
        }
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', filterFaqs);
    }

    setActiveButtons(activeCategory);
    filterFaqs();
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-sms-faq-page]');
    roots.forEach(initFaqSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();